import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';
import {
  setInlineBackgroundColor,
  setInlineTextColor
} from 'helpers/LandingPageUtils';
import css from 'styles/components/landing/melodyEditorialPromo.scss';

const MelodyEditorialPromo = ({ slotName, slotDetails, onLandingComponentClick, shouldLazyLoad }) => {
  const { heading, link, brandsrc, brandretina, brandalt, gae, copy, subtext, calltoaction, bgcolor, promos, textcolor, monetateId } = slotDetails;

  const makePromoImg = promo => {
    if (promo) {
      const { src, retina, alt } = promo;
      const imageProps = { src, retina, alt, shouldLazyLoad, className: css.lazyPromo };
      return <LandingPageImage {...imageProps} />;
    }
  };

  const makeHeadingText = () => heading && <h2 style={setInlineTextColor(textcolor)} className={css.headingText}>{heading}</h2>;

  const makeBrandImg = () => brandsrc &&
    <LandingPageImage
      src={brandsrc}
      retina={brandretina}
      alt={brandalt}
      shouldLazyLoad={shouldLazyLoad}
    />
  ;

  const makeCopy = () => copy && <p style={setInlineTextColor(textcolor)} className={css.copy}>{copy}</p>;

  const makeSubText = () => subtext && <p className={css.subtext}>{subtext}</p>;

  const makeCtaButton = () => calltoaction && <button>{calltoaction}</button>;

  const linkProps = {
    'className': css.linkWrap,
    'onClick': onLandingComponentClick,
    'data-eventlabel': 'melodyEditorialPromo',
    'data-slot-id': slotName,
    'data-eventvalue': gae,
    'data-monetate-id': monetateId
  };

  const styling = (textcolor === 'white') ? css.contentWrapCtaWhite : css.contentWrapCtaDefault;
  const contents = (
    <div className={styling} data-monetate-id={!link && monetateId ? monetateId : null}>
      <div className={css.promos}>
        {promos && promos.length && makePromoImg(promos[0])}
        {promos && promos.length && makePromoImg(promos[1])}
      </div>
      <div style={setInlineBackgroundColor(bgcolor)} className={css.mainContent}>
        {makeHeadingText()}
        {makeBrandImg()}
        {makeCopy()}
        {makeSubText()}
        {makeCtaButton()}
      </div>
    </div>
  );

  return link
    ?
    <LandingPageLink url={link} {...linkProps}>
      {contents}
    </LandingPageLink>
    :
    contents;
};

export default MelodyEditorialPromo;
